// extracted by mini-css-extract-plugin
module.exports = {"widgetBox":"Widget_widgetBox__pOqk8","widget":"Widget_widget__2QHOf"};